import { useMemo } from "react";
import api from "utils/axios";
import { showToast } from "components/ui/toast";
import { useFileUpload, useUpdatePhotoEdit } from "apis/prepareMarketing";

const getBackendOrigin = () =>
  (process.env.REACT_APP_BACKEND_URL || "").replace(/\/api\/v1\/?$/, "");

/**
 * Context value for @beleef/ai-photo-edit (EnhanceImageEditor, etc.).
 */
export function useAiPhotoEditContextValue() {
  return useMemo(
    () => ({
      apiClient: api,
      backendOrigin: getBackendOrigin(),
      showToast,
      orgParams: {},
      hooks: {
        useUpdatePhotoEdit,
        useFileUpload,
      },
    }),
    [],
  );
}
